import { Divider, Overlay, Stack, Text } from '@moda/om';
import React from 'react';
import { useSiteCreditOrRewardsSecondPayment } from '../../../hooks/useSiteCreditOrRewardsSecondPayment';
import { OrderState } from '../../../hooks/useUpdateOrder';
import { Box } from '../../Box';
import { LoadingBalls } from '../../LoadingBalls';
import { useOrderDetails } from '../../OrderDetails';
import { OrderDetailsSiteEarningsSection } from './OrderDetailsSiteEarningsSection';

export const OrderDetailsSiteCreditAndRewards = () => {
  const { orderSummary } = useOrderDetails();

  const { applyRewards, applySiteCredit, loading } = useSiteCreditOrRewardsSecondPayment();

  if (!orderSummary) return null;

  if (orderSummary.attributes.orderState !== OrderState.PayRemainingBalance) return null;

  const {
    useSiteCredit,
    useMoRewards,
    paymentSummary: { rewardsBalance, rewardsToBeUsed, siteCreditBalance, siteCreditToBeUsed }
  } = orderSummary.attributes;

  const hasMoRewards = Number(rewardsBalance.price) > 0;
  const hasSiteCredit = Number(siteCreditBalance.price) > 0;

  if (!hasMoRewards && !hasSiteCredit) return null;

  return (
    <Box className="OrderDetailsSiteCreditAndRewards">
      <Stack space={3}>
        <Text treatment="eyebrow">
          {hasMoRewards && "M'O Rewards"}
          {hasMoRewards && hasSiteCredit && ' & '} {hasSiteCredit && 'Site Credit'}
        </Text>

        {hasSiteCredit && (
          <OrderDetailsSiteEarningsSection
            checked={useSiteCredit}
            balance={siteCreditBalance}
            title="Site Credit"
            toBeUsed={siteCreditToBeUsed}
            onChange={applySiteCredit}
          />
        )}

        {hasMoRewards && hasSiteCredit && <Divider />}

        {hasMoRewards && (
          <OrderDetailsSiteEarningsSection
            checked={useMoRewards}
            balance={rewardsBalance}
            title="M'O Rewards"
            toBeUsed={rewardsToBeUsed}
            onChange={applyRewards}
          />
        )}
      </Stack>

      <Overlay show={loading}>
        <LoadingBalls />

        <Text treatment="eyebrow">Applying</Text>
      </Overlay>
    </Box>
  );
};
